"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6659],{

/***/ 39569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ProductListPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _components_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23920);
/* harmony import */ var _components_organisms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14254);
/* harmony import */ var _utils_arrays__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92886);








var ProductListPage = function(param) {
    var title = param.title, textContent = param.textContent, seoDescription = param.seoDescription, aboveProductsDescription = param.aboveProductsDescription, attributes = param.attributes, activeFilters = param.activeFilters, activeSortOption = param.activeSortOption, numberOfProducts = param.numberOfProducts, products = param.products, displayLoader = param.displayLoader, hasNextPage = param.hasNextPage, clearFilters = param.clearFilters, onLoadMore = param.onLoadMore, loadMoreError = param.loadMoreError, filters = param.filters, onOrder = param.onOrder, onAttributeFiltersChange = param.onAttributeFiltersChange, pricesFilter = param.pricesFilter, setPricesFilter = param.setPricesFilter, locationFilter = param.locationFilter, setLocationFilter = param.setLocationFilter, _disablePriceFiltering = param.disablePriceFiltering, disablePriceFiltering = _disablePriceFiltering === void 0 ? false : _disablePriceFiltering, _disableLocationFiltering = param.disableLocationFiltering, disableLocationFiltering = _disableLocationFiltering === void 0 ? false : _disableLocationFiltering, lenderInfo = param.lenderInfo, deliveryFilter = param.deliveryFilter, setDeliveryFilter = param.setDeliveryFilter, keyword = param.keyword, setKeyword = param.setKeyword, pageType = param.pageType, hasCollectionSale = param.hasCollectionSale, isWarehouseSaleCollection = param.isWarehouseSaleCollection, warehouseSaleTitle = param.warehouseSaleTitle, _isFetching = param.isFetching, isFetching = _isFetching === void 0 ? false : _isFetching, aboveProductContent = param.aboveProductContent;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), showFilters = ref[0], setShowFilters = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), infiniteScrollingMode = ref1[0], setInfiniteScrollingMode = ref1[1];
    products = (0,_utils_arrays__WEBPACK_IMPORTED_MODULE_5__/* .uniqueByKey */ .X)(products, "slug");
    var remainingProductCount = numberOfProducts - products.length;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (remainingProductCount <= 0) {
            setInfiniteScrollingMode(false);
        }
    }, [
        remainingProductCount
    ]);
    if (isWarehouseSaleCollection && !hasCollectionSale && !displayLoader && products.length) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .gC, {
            width: "100%",
            p: "0.5rem",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                w: "100%",
                textAlign: "center",
                mt: 4,
                children: [
                    warehouseSaleTitle,
                    " is not currently on, check back soon for our next big Warehouse Sale."
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .gC, {
        width: "100%",
        p: "0.5rem",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
            overflow: "visible",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_organisms__WEBPACK_IMPORTED_MODULE_3__/* .ProductListHeader */ .EX, {
                    title: title,
                    aboveProductsDescription: aboveProductsDescription,
                    seoDescription: seoDescription,
                    attributes: attributes,
                    showFilters: showFilters,
                    setShowFilters: setShowFilters,
                    activeFilters: activeFilters,
                    activeSortOption: activeSortOption,
                    numberOfProducts: numberOfProducts,
                    clearFilters: clearFilters,
                    locationFilter: locationFilter,
                    onLocationFilterChange: setLocationFilter,
                    onPricesFilterChange: setPricesFilter,
                    pricesFilter: pricesFilter,
                    deliveryFilter: deliveryFilter,
                    setDeliveryFilter: setDeliveryFilter,
                    onOrder: onOrder,
                    filters: filters,
                    onAttributeFiltersChange: onAttributeFiltersChange,
                    lenderInfo: lenderInfo,
                    infiniteScrollingMode: infiniteScrollingMode,
                    keyword: keyword,
                    setKeyword: setKeyword,
                    displayLoader: displayLoader,
                    pageType: pageType,
                    aboveProductContent: aboveProductContent
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_organisms__WEBPACK_IMPORTED_MODULE_3__/* .FilterSidebar */ .zA, {
                    show: showFilters,
                    hide: function() {
                        return setShowFilters(false);
                    },
                    onAttributeFiltersChange: onAttributeFiltersChange,
                    attributes: attributes,
                    filters: filters,
                    pricesFilter: pricesFilter,
                    setPricesFilter: setPricesFilter,
                    locationFilter: locationFilter,
                    setLocationFilter: setLocationFilter,
                    disablePriceFiltering: disablePriceFiltering,
                    disableLocationFiltering: disableLocationFiltering,
                    deliveryFilter: deliveryFilter,
                    setDeliveryFilter: setDeliveryFilter,
                    keyword: keyword,
                    setKeyword: setKeyword
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                    width: "100%",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_organisms__WEBPACK_IMPORTED_MODULE_3__/* .ProductList */ .cm, {
                        products: products,
                        numberOfProducts: numberOfProducts,
                        canLoadMore: hasNextPage,
                        loading: displayLoader,
                        onLoadMore: onLoadMore,
                        loadMoreError: loadMoreError,
                        infiniteScrollingMode: infiniteScrollingMode,
                        setInfiniteScrollingMode: setInfiniteScrollingMode,
                        deliveryFilter: deliveryFilter,
                        hasCollectionSale: hasCollectionSale,
                        isWarehouseSaleCollection: isWarehouseSaleCollection,
                        warehouseSaleTitle: warehouseSaleTitle,
                        isFetching: isFetching
                    })
                }),
                !infiniteScrollingMode && remainingProductCount > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                    children: !_app_constants__WEBPACK_IMPORTED_MODULE_1__/* .ssrMode */ .$m && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Center */ .M5, {
                        padding: 10,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_atoms__WEBPACK_IMPORTED_MODULE_2__.Button, {
                            width: "300px",
                            testingContext: "LoadMoreButton",
                            onClick: function() {
                                setInfiniteScrollingMode(true);
                                onLoadMore();
                            },
                            children: "Load more items (".concat(remainingProductCount.toLocaleString(), ")")
                        })
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Center */ .M5, {
                    paddingLeft: "6px",
                    paddingRight: "6px",
                    maxWidth: "1024px",
                    marginX: "auto",
                    paddingTop: "1.5rem",
                    paddingBottom: "1.5rem",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_atoms__WEBPACK_IMPORTED_MODULE_2__.RichTextEditorContent, {
                        jsonData: textContent
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 79114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useAttributesFiltering; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _utils_ssr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11420);








var defaultOrderColors = [
    "black",
    "blue",
    "pink",
    "red",
    "white"
];
var useAttributesFiltering = function(param) {
    var categoryId = param.categoryId, collectionId = param.collectionId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), attributes = ref[0], setAttributes = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var fetchAttributes = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var attributesData, normalizeAttributesData, lenderRatingAttribute;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_utils_ssr__WEBPACK_IMPORTED_MODULE_2__/* .getShopAttributes */ .Ie)({
                                    categoryId: categoryId,
                                    collectionId: collectionId
                                })
                            ];
                        case 1:
                            attributesData = _state.sent();
                            normalizeAttributesData = attributesData.map(function(attribute) {
                                if (attribute.slug === "size") {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, attribute), {
                                        startFrom: 1
                                    });
                                }
                                if (attribute.slug === "colour") {
                                    var values = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(attribute === null || attribute === void 0 ? void 0 : attribute.values);
                                    var sortedValues = values.sort(function(a, b) {
                                        var indexOfA = defaultOrderColors.indexOf(a.slug);
                                        var indexOfB = defaultOrderColors.indexOf(b.slug);
                                        if (indexOfA === -1) {
                                            return 1;
                                        }
                                        if (indexOfB === -1) {
                                            return -1;
                                        }
                                        return indexOfA < indexOfB ? -1 : 1;
                                    });
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, attribute), {
                                        values: sortedValues
                                    });
                                }
                                return attribute;
                            });
                            lenderRatingAttribute = {
                                slug: "lenderRating",
                                name: "Lender Rating",
                                values: _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .lenderRatingOptions */ .zF
                            };
                            setAttributes((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(normalizeAttributesData).concat([
                                lenderRatingAttribute
                            ]));
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAttributes() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchAttributes();
    }, [
        categoryId,
        collectionId
    ]);
    return attributes;
};


/***/ }),

/***/ 66015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useProductLoading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);
/* harmony import */ var _app_views_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78676);
/* harmony import */ var _utils_filters__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97126);










var useProductLoading = function(param) {
    var ssrData = param.ssrData, filters = param.filters, ids = param.ids, clientFiltered = param.clientFiltered, hasDeliveryFilter = param.hasDeliveryFilter, postcodes = param.postcodes, lenderSlug = param.lenderSlug, queryType = param.queryType;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loadMoreError = ref1[0], setLoadMoreError = ref1[1];
    var loadMore = function() {};
    var loading = false;
    // For SSR this comes from getServerSideProps
    var clientData = ssrData;
    // The SSR data can get stale e.g. when going back from a product detail
    // Although in this case a SSR is performed, next.js will miss params
    // that were added an the SSR path gets out of sync with client path
    var ssrDataIsStale = !_app_constants__WEBPACK_IMPORTED_MODULE_2__/* .ssrMode */ .$m && ((0,_utils_filters__WEBPACK_IMPORTED_MODULE_4__/* .getBrowserPath */ .YA)(router) === router.asPath || hasDeliveryFilter || clientFiltered);
    if (!_app_constants__WEBPACK_IMPORTED_MODULE_2__/* .ssrMode */ .$m) {
        var ref2, ref3;
        // Query products but we don't use the result on initial client render
        var query = (0,_app_views_queries__WEBPACK_IMPORTED_MODULE_3__/* .useProductsQuery */ .k)(filters, ids, ssrDataIsStale ? undefined : (clientData === null || clientData === void 0 ? void 0 : (ref2 = clientData.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.endCursor) || undefined, postcodes || [], lenderSlug || "", queryType);
        clientData = (ref3 = query.data) === null || ref3 === void 0 ? void 0 : ref3.products;
        loadMore = query.loadMore;
        loading = query.loading;
    }
    var products = (clientData === null || clientData === void 0 ? void 0 : (ref = clientData.edges) === null || ref === void 0 ? void 0 : ref.map(function(e) {
        return e.node;
    })) || [];
    var pageInfo = clientData === null || clientData === void 0 ? void 0 : clientData.pageInfo;
    var numberOfProducts = (clientData === null || clientData === void 0 ? void 0 : clientData.totalCount) || 0;
    var handleLoadMore = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var ref, loadMoreResult;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!loadMore) return [
                            2
                        ];
                        return [
                            4,
                            loadMore(function(prev, next) {
                                var ref, ref1, ref2;
                                return {
                                    products: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, prev.products), {
                                        edges: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(((ref = prev.products) === null || ref === void 0 ? void 0 : ref.edges) || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(((ref1 = next.products) === null || ref1 === void 0 ? void 0 : ref1.edges) || [])),
                                        pageInfo: (ref2 = next.products) === null || ref2 === void 0 ? void 0 : ref2.pageInfo
                                    })
                                };
                            }, pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor)
                        ];
                    case 1:
                        loadMoreResult = _state.sent();
                        if (loadMoreResult === null || loadMoreResult === void 0 ? void 0 : (ref = loadMoreResult.error) === null || ref === void 0 ? void 0 : ref.networkError) {
                            setLoadMoreError(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        products: products,
        loading: loading,
        pageInfo: pageInfo,
        numberOfProducts: numberOfProducts,
        handleLoadMore: handleLoadMore,
        loadMoreError: loadMoreError
    };
};


/***/ }),

/***/ 78676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ productList; },
/* harmony export */   "k": function() { return /* binding */ useProductsQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22841);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7905);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23149);
/* harmony import */ var _temp_core_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32236);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  query ProductList(\n    $after: String\n    $first: Int!\n    $sortBy: ProductOrder\n    $filter: ProductFilterInput\n    $channel: String\n    $queryType: String\n    $filterIsb: Boolean\n    $similarProductId: ID\n  ) {\n    products(\n      after: $after\n      first: $first\n      sortBy: $sortBy\n      filter: $filter\n      channel: $channel\n      public: true\n      queryType: $queryType\n      filterIsb: $filterIsb\n      similarProductId: $similarProductId\n    ) {\n      edges {\n        node {\n          ...BasicProductFields\n          ...ProductPricingFieldSF\n          ...ShippingMethods\n          ...BasicProductVariants\n        }\n      }\n      totalCount\n      pageInfo {\n        ...PageInfo\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var productList = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject(), _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .basicProductFragment */ .kf, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .productPricingFragment */ .XA, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .shippingMethodsFragment */ .v6, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .basicProductVariantFragment */ .vo, _graphql_fragments__WEBPACK_IMPORTED_MODULE_2__/* .pageInfo */ .x1);
var useProductsQuery = function(filters, ids) {
    var after = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, postcodes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], lenderSlug = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", qType = arguments.length > 5 ? arguments[5] : void 0;
    var ref, ref1, ref2;
    var categoryId = ids.categoryId, collectionId = ids.collectionId;
    var categorySlugs = filters.categorySlugs;
    var variables = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        filter: {
            prices: filters === null || filters === void 0 ? void 0 : (ref = filters.prices) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var lte = param.lte, gte = param.gte;
                return {
                    lte: lte,
                    gte: gte
                };
            }),
            lenderRating: {
                gte: ((ref2 = filters === null || filters === void 0 ? void 0 : (ref1 = filters.lenderRating) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
                    return a - b;
                })) === null || ref2 === void 0 ? void 0 : ref2[0]) || null
            },
            lenderSlug: lenderSlug,
            collections: collectionId && qType !== "warehouse_sale" ? [
                collectionId
            ] : undefined,
            categories: categoryId && !categorySlugs ? [
                categoryId
            ] : undefined,
            channel: _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .channelSlug */ .m_,
            attributes: filters.attributes ? (0,_temp_core_utils__WEBPACK_IMPORTED_MODULE_4__/* .convertToAttributeScalar */ .rh)(filters.attributes) : {},
            postcodes: postcodes.length ? postcodes : filters.postcodes,
            availableDeliveryDate: filters.availableDeliveryDate,
            availableDeliveryPostcode: filters.availableDeliveryPostcode,
            search: filters === null || filters === void 0 ? void 0 : filters.search,
            categorySlugs: categorySlugs
        },
        channel: _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .channelSlug */ .m_,
        first: filters.pageSize || _app_constants__WEBPACK_IMPORTED_MODULE_1__/* .productsPerPage */ .ct,
        after: after || undefined,
        sortBy: (0,_temp_core_utils__WEBPACK_IMPORTED_MODULE_4__/* .convertSortByFromString */ .dz)((filters === null || filters === void 0 ? void 0 : filters.sortBy) || ""),
        public: true,
        queryType: qType,
        filterIsb: (filters === null || filters === void 0 ? void 0 : filters.filterIsb) || false
    }, (filters === null || filters === void 0 ? void 0 : filters.similarProductId) && {
        similarProductId: filters.similarProductId
    });
    return (0,_graphql_queries__WEBPACK_IMPORTED_MODULE_3__/* .useTypedQuery */ .OK)(productList, {
        variables: variables,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        returnPartialData: true,
        skip: false
    });
};


/***/ })

}]);